//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const CampaignsNav = () => {
  return (
    <NavMenuItem
      activeNavGroup={NavGroup.CAMPAIGNS}
      state='campaigns'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.CAMPAIGNS_NAV}
    >
      Campaigns
    </NavMenuItem>
  );
};
